import { js_utils } from "./frfr-js-utils";


/*
FrFr FRIENDLY FRAMEWORK
frfr-response-utils FRFR RESPONSE UTILS
Version ID: 1a 2023-09-25r1
by 
// Please describe here if you customized this file
*/


/*
DOCUMENTATION:

frfr_erf je skracenica za frfr_error_response_format
frfr_srf je skracenica za frfr_success_response_format

The rest of the documentation is in the frfr-res-docs.js file.

*/


const frfr_res_utils = {}; //


const erf_types = {};
erf_types.FORM_VALIDATION = 'FORM_VALIDATION';

frfr_res_utils.is_erf = (response) => {
  if (response && response.error === true && typeof response.frfr_erf !== 'undefined') {
    return true;
  }
  return false;
};


frfr_res_utils.is_erf_form_validation_error = (frfr_erf_res) => {
  if (frfr_erf_res.error === true && typeof frfr_erf_res.frfr_erf !== 'undefined' && frfr_erf_res.error_type === 'FORM_VALIDATION') {
    return true;
  }
  return false;
};


frfr_res_utils.is_srf = (response) => {
  if (response && response.success === true && typeof response.frfr_srf !== 'undefined') {
    return true;
  }
  return false;
};


frfr_res_utils.erf_extract_form_errors = (frfr_erf_res) => {
  // return object where every property key is a name of a input field which conatin error. And its value is description of a error in that field.
  let errors = {};
  if (frfr_erf_res.error_type === 'FORM_VALIDATION') {
    // FORM_VALIDATION ERROR
    if (frfr_erf_res.extra_data && frfr_erf_res.extra_data.form_errors) {
      // form validation errors must be object (not array).
      if (js_utils.is_object(frfr_erf_res.extra_data.form_errors)) {
        errors = frfr_erf_res.extra_data.form_errors; // field validation errors
      }
    }
  }
  return errors;
};


frfr_res_utils.erf_pack_response = (obj) => {
  // pack ERF error response
  let res_data = {
    error: true,
    frfr_erf: true,
    frfr_erf_version: "1",
  };
  if (js_utils.is_object(obj)) {
    if (obj.error_type) {
      res_data.error_type = obj.error_type;
    }
    if (obj.payload || obj.payload === false) {
      res_data.payload = obj.payload;
    }
    if (js_utils.is_object(obj.meta)) {
      res_data.meta = { ...obj.meta };
    }
  }
  // return frfr_wrf ERROR RESPONSE
  return res_data;
};

frfr_res_utils.srf_pack_response = (obj) => {
  // pack SRF success response
  let res_data = {
    success: true,
    frfr_srf: true,
    frfr_srf_version: "1",
  };
  if (obj.success === true || obj.success === false) {
    res_data.success = obj.success;
  }
  if (js_utils.is_object(obj)) {
    if (obj.payload || obj.payload === false) {
      res_data.payload = obj.payload;
    }
    if (js_utils.is_object(obj.meta)) {
      /*
      if (obj.meta.readme) {
        if (!res_data.meta) {
          res_data.meta = {};
        }
        res_data.meta.readme = obj.meta.readme;
      }
      */
      res_data.meta = { ...obj.meta };
    }
  }
  // return frfr_srf SUCCESS RESPONSE
  return res_data;
};

frfr_res_utils.srf_extract_payload = (srf) => {
  // pack success response
  // console.log(srf);
  let payload;
  if (srf.payload) {
    payload = srf.payload;
  }
  return payload;
};

export { frfr_res_utils };
